import React from 'react';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class MountainLocationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mountains: [],
      locations: []
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    this.everestRepository.searchMountain({}, (data) => {
      this.setState({ mountains: data.content });
    });
  }

  render() {
    return (
      <>
        <NavigationBar />

        <br />
        <div className={"container"}>
          <div className={"row"}>
            <table className={"table"}>
              <thead>
                <th>이름</th>
              </thead>
            </table>
          </div>
        </div>

        <br />
        <div className={"container"}>
          <div className={"row"}>
            <table className={"table"}>
              <thead></thead>
            </table>
          </div>
        </div>
      </>
    );
  }
}

export { MountainLocationList };
